import * as terminals from 'app/mocks/data/machines/all/terminals'

export const terminalDiagnostic1 = {
    machine: {
        id: terminals.terminal1.id,
        type: terminals.terminal1.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2022-12-27 08:26:49.219717',
        last_heartbeat_connection: '2022-12-27 08:26:49.219717',
    },
}

export const terminalDiagnostic2 = {
    machine: {
        id: terminals.terminal2.id,
        type: terminals.terminal2.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2022-12-27 08:26:49.219717',
        last_heartbeat_connection: '2022-12-27 08:26:49.219717',
    },
}

export const terminalDiagnostic3 = {
    machine: {
        id: terminals.terminal3.id,
        type: terminals.terminal3.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2009-12-27 08:26:49.219717',
        last_heartbeat_connection: '2010-12-27 08:26:49.219717',
    },
}

export const terminalDiagnostic4 = {
    machine: {
        id: terminals.terminal4.id,
        type: terminals.terminal4.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2009-12-27 08:26:49.219717',
        last_heartbeat_connection: '2010-12-27 08:26:49.219717',
    },
}
